module.exports = __webpack_public_path__ + "static/25-43c23c1e9304f91bb53a3c87368654ad.jpg";